import { render } from "./GoTop.vue?vue&type=template&id=0243ebd5&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=0243ebd5&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0243ebd5"]])

export default __exports__